<script setup>
import { computed, ref } from 'vue';
import { useMessageContext } from '../../provider.js';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { MESSAGE_VARIANTS } from '../../constants';
import { wrapPhoneNumbers } from 'dashboard/helper/phoneNumberHelper.js';
import { usePhoneClick } from 'dashboard/composables/usePhoneClick.js';
import ContactNameModal from 'dashboard/components-next/ContactNameModal.vue';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

const { variant } = useMessageContext();
const contactNameModalRef = ref(null);

const promptContactName = () => {
  return contactNameModalRef.value?.open();
};

let phoneClickHandler = null;
try {
  const { handlePhoneClick } = usePhoneClick({ promptContactName });
  phoneClickHandler = handlePhoneClick;
} catch {
  // Router/store not available — phone click disabled
}

const formattedContent = computed(() => {
  if (variant.value === MESSAGE_VARIANTS.ACTIVITY) {
    return props.content;
  }

  const html = new MessageFormatter(props.content).formattedMessage;
  try {
    return wrapPhoneNumbers(html);
  } catch {
    return html;
  }
});

const onClick = event => {
  if (!phoneClickHandler) return;

  const phoneLink = event.target.closest('.phone-link');
  if (!phoneLink) return;

  event.preventDefault();
  event.stopPropagation();

  const { phoneNumber } = phoneLink.dataset;
  if (phoneNumber) {
    phoneClickHandler(phoneNumber);
  }
};
</script>

<template>
  <span
    v-dompurify-html="formattedContent"
    class="prose prose-bubble"
    @click="onClick"
  />
  <ContactNameModal ref="contactNameModalRef" />
</template>
